import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import '@/index.css';
import App from '@/App';
import { AppProvider } from '@/context/AppContext';
import { Toaster } from '@/components/ui/sonner';
import { bootTheme } from '@/lib/theme';

// Apply any cached theme instantly (before first paint) to avoid a flash.
bootTheme();

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, refetchOnWindowFocus: false, retry: 1 } },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <QueryClientProvider client={queryClient}>
    <AppProvider>
      <App />
      <Toaster position="top-center" richColors />
    </AppProvider>
  </QueryClientProvider>
);
